import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';
import _ from 'lodash';
import fastStorage from '../../fastStorage';

export class EdiExcelUploadListItem extends SearchModelBase {
    // For search
    query: string|null = null;
    queryOrderBy: string|null = null;
    txtParams1: string|null = null;
    txtParams2: string|null = null;
    txtParams3: string|null = null;
    txtParams4: string|null = null;
    txtParams5: string|null = null;
    txtParams6: string|null = null;

    public static getExportCollection(): XCol.XExportColumn[] {
        return fastStorage['customize-list-column'];
    };
}
